import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionsKey } from '../../utils/keys';
export const useCollections = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const collectionsKey = getCollectionsKey({ variables, fields });
    return useQuery(collectionsKey, () => client === null || client === void 0 ? void 0 : client.collections.list({ ...variables }, fields), useQueryOptions);
};
//# sourceMappingURL=useCollections.js.map